import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function CoreBenefit() {
  return <section className="py-24 px-6 bg-dark overflow-hidden" data-id="element-17">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-18">
        <div data-id="element-19">
          <FadeIn data-id="element-20">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-6 leading-tight" data-id="element-21">
              Watch Your Event <br data-id="element-22" />
              <span className="text-gold italic" data-id="element-23">Unfold Live</span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-24">
            <p className="text-lg text-cream-dark/80 mb-6 font-light leading-relaxed" data-id="element-25">
              As guests take photos, they instantly appear in your private
              gallery. See your event through everyone's eyes — in real time.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-26">
            <div className="bg-dark-lighter p-6 rounded-xl border border-gold/20 mb-10" data-id="element-27">
              <p className="text-cream text-lg" data-id="element-28">
                <span className="text-gold font-semibold" data-id="element-29">
                  After the event:
                </span>{' '}
                Your link becomes a beautiful digital album you keep forever.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-30">
            <Button data-id="element-31">👉 Get Yours Now</Button>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} direction="left" className="relative flex justify-center lg:justify-end" data-id="element-32">
          <div className="relative w-full max-w-[320px]" data-id="element-33">
            {/* Phone frame effect */}
            <div className="absolute inset-0 bg-gold/20 rounded-[40px] blur-xl" data-id="element-34"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dDCg88ksZ85JE1QNXtPQni/appliveeventgallery.png" alt="TapShare live event gallery on mobile phone" className="relative z-10 w-full h-auto rounded-[32px] border-[6px] border-dark-lighter shadow-2xl" data-id="element-35" />

            {/* Floating elements for visual interest */}
            <div className="absolute -top-6 -right-6 w-20 h-20 bg-dark rounded-full border border-gold/30 flex items-center justify-center shadow-lg z-20 animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-36">
              <span className="text-2xl" data-id="element-37">✨</span>
            </div>
            <div className="absolute bottom-12 -left-8 w-16 h-16 bg-dark rounded-full border border-gold/30 flex items-center justify-center shadow-lg z-20 animate-bounce" style={{
            animationDuration: '4s',
            animationDelay: '1s'
          }} data-id="element-38">
              <span className="text-xl" data-id="element-39">📸</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}